import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData} from "../../../core/reel/ReelState";
import {WalkOfShame} from "../../WalkOfShame";
import {WalkOfShameGameMode} from "../../server/WalkOfShameGameMode";
import {WalkOfShameGameConfig} from "../../WalkOfShameGameConfig";
import {WalkOfShameSymbol} from "../../symbol/WalkOfShameSymbol";
import {WalkOfShameSymbolState} from "../../symbol/WalkOfShameSymbolConfig";
import {TimelineLite} from "gsap";
import {WalkOfShameSound} from "../../sound/WalkOfShameSound";

export class Scatter2LandingController extends ReelStopPresentationController {
    constructor() {
        super("Scatter2LandingController");
    }

    protected onReelBounce(data: IReelStateEventData): Promise<any> {
        if (WalkOfShame.model.parsedGameData.mode === WalkOfShameGameMode.FREESPIN && data.reelId === 0 && WalkOfShame.model.parsedGameData.s2SymId > -1 && !WalkOfShame.stickyS2.visible && !this.isSkip) {
            WalkOfShame.model.fsLeftCtr += 3;
            WalkOfShame.additionalFS.showAdditionalFS(0, WalkOfShame.model.parsedGameData.s2SymId, 3, WalkOfShame.model.fsLeftCtr);
        }

        const s2SymId: number = WalkOfShame.model.parsedGameData.s2SymId;
        if (data.reelId === 0 && !WalkOfShame.stickyS2.visible && !this.isSkip && s2SymId > -1) {
            const symbol: WalkOfShameSymbol = WalkOfShame.reels[0].getSymbol(s2SymId + 1),
                anim: TimelineLite = symbol.getStateAnimation(WalkOfShameSymbolState.LANDING);

            if (WalkOfShame.model.parsedGameData.mode === WalkOfShameGameMode.NORMAL) {
                WalkOfShameSound.soundPlayer.playTrack({
                    name: WalkOfShameSound.S2_LAND
                });
            } else {
                WalkOfShameSound.soundPlayer.playTrack({
                    name: WalkOfShameSound.S2_LAND_FS
                });
            }

            return Promise.resolve(anim);
        }

        return Promise.resolve();
    }

    protected async onReelStopped(data: IReelStateEventData): Promise<any> {
        // #65
        if (WalkOfShameGameConfig.IS_LUCKY_DRAW && data.reelId === 0) {
            WalkOfShameGameConfig.IS_ANTICIPATING = false;

            WalkOfShame.anticipation.stopAnticipation();
        }

        await Promise.resolve();
    }
}